import { atomWithReset } from "jotai/utils";

type IntegrationModalData = {
  lampu_product_id: string;
  product_name: string;
};

type IntegrationModalState = {
  visible: boolean;
  data: IntegrationModalData | null;
};

export const crmProductModalAtom = atomWithReset<IntegrationModalState>({
  visible: false,
  data: null
});

export const bclProductModalAtom = atomWithReset<IntegrationModalState>({
  visible: false,
  data: null
});

export const erfinaProductModalAtom = atomWithReset<IntegrationModalState>({
  visible: false,
  data: null
});
